import { TYPE_UNITEL_REVENUE, TYPE_VM_UNITEL } from "./type";

export const getDataRevenueUnitel = (url) => {
  return {
    type: TYPE_UNITEL_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataVmUnitel = (url) => {
  return {
    type: TYPE_VM_UNITEL,
    meta: {
      url,
      method: "GET",
    },
  };
};
